export default "__VITE_PUBLIC_ASSET__389011d8__"